var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 42,
    viewBox: "0 0 50 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 31.4175L25 39.7508M25 39.7508L33.3333 31.4175M25 39.7508V21.0008M43.5 33.6883C45.3112 32.4147 46.6695 30.597 47.3777 28.4991C48.0859 26.4011 48.1071 24.1321 47.4383 22.0213C46.7696 19.9105 45.4456 18.0677 43.6585 16.7603C41.8714 15.453 39.7142 14.7491 37.5 14.7508H34.875C34.2484 12.3089 33.076 10.0409 31.4461 8.11767C29.8162 6.19441 27.7712 4.66596 25.465 3.64741C23.1589 2.62885 20.6518 2.14673 18.1324 2.23733C15.6129 2.32793 13.1469 2.9889 10.9199 4.17048C8.69292 5.35205 6.76298 7.02344 5.2754 9.05881C3.78783 11.0942 2.78137 13.4405 2.33181 15.9211C1.88224 18.4018 2.00128 20.9521 2.67997 23.38C3.35866 25.808 4.5793 28.0504 6.25001 29.9383",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIcon);
export default __webpack_public_path__ + "static/media/cloudIcon.5663591b886551c525e7eb05953ffcef.svg";
export { ForwardRef as ReactComponent };